// frontend/src/components/routineWizard/wizardPrompt.js
//
// Pure, side-effect-free builder for the AI prompt sent to /routines/generate-ai.
// Reads the localized template from i18n via the t() function passed in.

const VOLUME_BY_TIME = {
  30: { exercises: 4,  sets: 3 },
  45: { exercises: 5,  sets: '3–4' },
  60: { exercises: '6–7', sets: '3–4' },
  90: { exercises: '8–9', sets: 4 },
};

const OBJECTIVE_LABEL_KEY = {
  muscle:   'routines.wizard.step.objective.muscle.title',
  fat_loss: 'routines.wizard.step.objective.fatLoss.title',
  strength: 'routines.wizard.step.objective.strength.title',
  general:  'routines.wizard.step.objective.general.title',
};

const OBJECTIVE_SET_REPS = {
  muscle:   '3–4 × 8–12',
  fat_loss: '3 × 12–15, rest 60–90s',
  strength: '4–5 × 4–6 (compounds), 3 × 8–10 (accessories)',
  general:  '3 × 8–12',
};

const EXPERIENCE_LABEL_KEY = {
  beginner:     'routines.wizard.step.experience.beginner.title',
  intermediate: 'routines.wizard.step.experience.intermediate.title',
  advanced:     'routines.wizard.step.experience.advanced.title',
};

const DIFFICULTY_RULE = {
  beginner:     'fundamental compounds + machine variants only; no advanced techniques',
  intermediate: 'standard hypertrophy/strength schemes; drop sets allowed',
  advanced:     'full latitude — supersets, drop sets, accommodating resistance',
};

const PRIMARY_EQUIPMENT_DESC = {
  full_gym:    'Full gym (barbells, racks, machines, cables, dumbbells)',
  dumbbells:   'Home dumbbells and a bench (no barbell or machines)',
  bands:       'Resistance bands and bodyweight only',
  bodyweight:  'Bodyweight only — no equipment',
};

const SPECIFIC_LABEL_KEY = (key) => `routines.wizard.step.equipment.items.${key}`;

export function buildWizardPrompt(answers, t) {
  const { experience, equipment, objective, days, time } = answers;
  const volume = VOLUME_BY_TIME[time] || VOLUME_BY_TIME[60];

  let equipmentDesc;
  if (equipment.specific && equipment.specific.length > 0) {
    equipmentDesc = equipment.specific.map(k => t(SPECIFIC_LABEL_KEY(k))).join(', ');
  } else {
    equipmentDesc = PRIMARY_EQUIPMENT_DESC[equipment.primary] || PRIMARY_EQUIPMENT_DESC.full_gym;
  }

  return t('routines.wizard.promptTemplate', {
    objective: t(OBJECTIVE_LABEL_KEY[objective]),
    experience: t(EXPERIENCE_LABEL_KEY[experience]),
    days,
    time,
    exercisesPerDay: volume.exercises,
    setsPerExercise: volume.sets,
    equipment: equipmentDesc,
    difficultyRule: DIFFICULTY_RULE[experience],
    objectiveSetReps: OBJECTIVE_SET_REPS[objective],
  });
}

export function difficultyForExperience(experience) {
  return { beginner: 'Beginner', intermediate: 'Intermediate', advanced: 'Advanced' }[experience] || 'Intermediate';
}
